import { render, staticRenderFns } from "./MyTablesList.vue?vue&type=template&id=397e10b4"
import script from "./MyTablesList.vue?vue&type=script&lang=js"
export * from "./MyTablesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports